import React, { useState } from "react";
import "./Login.css";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { Controller, useForm } from "react-hook-form";
import { HttpService } from "../../service/HttpService";
import * as Yup from "yup";
import { Input, Button } from "reactstrap";
import { Link, useHistory } from "react-router-dom";
import Header from "../../Common/Header/Header";
import AlertComponent from "../../Common/Alert/Alert";

const Login = () => {
  const history = useHistory();

  var [username, setEmail] = useState("");
  var [password, setPassword] = useState("");
  var [color, setColor] = useState("");
  var [message, setMessage] = useState("");
  var [alert, setAlert] = useState(false);

  const httpService = new HttpService();

  const { handleSubmit, errors, control } = useForm({ mode: "onBlur" });

  const onDismiss = () => {
    setAlert(false);
  };

  const login = () => {
    httpService
      .login("authenticate", { username: username, password: password })
      .then(
        (response) => {
          localStorage.setItem("token", response.data.id_token);
          getUserInfo(response.data.id_token);
          history.push("/home");
          console.log(response.data);
        },
        (error) => {
          console.log(error);
          if (error.response.data != undefined) {
            const errMessage = error.response.data;
            setColor("danger");
            setMessage(errMessage.message);
            setAlert(true);
          }
        }
      );
  };

  const getUserInfo = (accessToken) => {
    httpService.getApi2("account", accessToken).then((response) => {
      localStorage.setItem("user", JSON.stringify(response.data));
    });
  };

  return (
    <>
      <Header isBackBtnShow={true} loggedInUser={false} />
      <div className="login_sec">
        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          validationSchema={Yup.object().shape({
            email: Yup.string()
              .email("Email is invalid")
              .required("Email is required"),
            password: Yup.string()
              .min(6, "Password must be at least 6 characters")
              .required("Password is required"),
          })}
          onSubmit={(fields) => {
            console.log("SUCCESS!! :-)\n\n" + JSON.stringify(fields, null, 4));
            history.push("/Redem");
            const REST_API_URL = "";
            // fetch(REST_API_URL, {
            //   method: 'post',
            //   body: JSON.stringify(fields)
            // }).then(response=> {
            //   if (response.ok) {
            //     return response.json();
            //   } else {
            //     throw new Error('Something went wrong');
            //   }
            // }).then(data => {
            //   console.log(data);
            // }).catch((error) => {
            //   console.log(error);
            // });
          }}
          render={({ errors, status, touched }) => (
            <Form>
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <Input
                  name="username"
                  type="text"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    maxLength: {
                      value: 25,
                      message: "Value must be less then 25",
                    },
                  }}
                  className="form-control"
                  onChange={(event) => {
                    setEmail(event.target.value);
                    return event.target.value;
                  }}
                />
              </div>
              <div className="form-group mb-3">
                <label htmlFor="password">Password</label>
                <Input
                  name="password"
                  type="password"
                  control={control}
                  rules={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                    maxLength: {
                      value: 25,
                      message: "Value must be less then 25",
                    },
                  }}
                  className="form-control"
                  onChange={(event) => {
                    setPassword(event.target.value);
                    return event.target.value;
                  }}
                />
              </div>
              <div className="form-group mb-2">
                <Button
                  type="submit"
                  className="btn  login_btn"
                  onClick={handleSubmit(login)}
                >
                  Login
                </Button>
              </div>
              {/* <div className="or_sec text-center">
                            <span className="text-uppercase text-bold">or</span>
                        </div>
                        <div className="social-logins">
                            <span><i class="fab fa-facebook-f"></i></span>
                            <span><i className="fab fa-google-plus-g"></i></span>
                        </div> */}
              <p style={{ color: "#c94d3d" }}>
                Don't have an account ?{" "}
                <Link
                  style={{
                    textDecoration: "none",
                    color: "#c94d3d",
                    fontWeight: 800,
                  }}
                  to="/signup"
                >
                  Sign up
                </Link>
              </p>
            </Form>
          )}
        />
        <AlertComponent
          color={color}
          message={message}
          alert={alert}
          onDismiss={onDismiss}
        />
      </div>
    </>
  );
};
export default Login;
